import AbstractEffect from 'effects/AbstractEffect.js';
import {LIVE_FX} from 'constants/effect-types.js';
import LockableEffect from "effects/LockableEffect.js";

class LiveEffect extends LockableEffect(AbstractEffect) {
    constructor(name, effect, track) {
        super(name, track);
        this.effect = effect;
    }


    get subSequence() {
        if (this.track.tracks) {
            return this.track;
        }
        return this.track.subSequence;
    }


    isMidiEffect() {
        return false;
    }

    dispose() {}

    getParameters() {
        return  [];
    }

    getEffectType() {
        return LIVE_FX;
    }

    getJson() {
        let json = super.getJson();
        json.effect = this.effect;
        return json;
    }
   
}

export default LiveEffect;
